import { Button, ButtonSizesEnum, ButtonThemesEnum } from '@propertyfinder/button';
import { domClassMerge } from '@propertyfinder/helpers';
import { IconSpriteWhatsappFilled } from '@propertyfinder/icons';
import { FunctionComponent, h } from 'preact';
import { useEffect, useState } from 'preact/hooks';

import { i18nTranslate } from 'common/helper/i18n/translate';
import { WhatsappContext } from 'common/module/whatsapp/context';
import { WhatsappEventEnum } from 'common/module/whatsapp/event.enum';

import { GalleryNudgeWhatsappComponentPropsInterface } from './component-props.interface';

export const GalleryNudgeWhatsappComponentFactory = (whatsappContext: WhatsappContext) => {
  const Component: FunctionComponent<GalleryNudgeWhatsappComponentPropsInterface> = ({ ...props }) => {
    const [whatsAppClicked, setWhatsAppClicked] = useState(false);

    useEffect(() => {
      whatsappContext.getEventEmitter().addListener(WhatsappEventEnum.CLICKED, (id) => onWhatsappClick(id as string));

      return (): void => {
        whatsappContext
          .getEventEmitter()
          .removeListener(WhatsappEventEnum.CLICKED, (id) => onWhatsappClick(id as string));
      };
    }, []);

    const onWhatsappClick = (id: string): void => {
      if (id === props.propertyId) {
        setWhatsAppClicked(true);
      }
    };

    return (
      <div className='whatsapp-nudge' style={props.style || ''} data-testid='gallery-nudge-whatsapp'>
        {props.children}
        <p className='whatsapp-nudge__title'>{i18nTranslate('PropertyCard_GalleryWhatsAppNudgeTitle')}</p>
        <Button
          disabled={whatsAppClicked}
          theme={ButtonThemesEnum.PRIMARY}
          size={ButtonSizesEnum.SMALL}
          onClick={(e: Event): void => {
            whatsappContext.onClickWhatsApp(props.propertyId, e);
          }}
          icon={{
            component: IconSpriteWhatsappFilled,
            position: 'prefix',
            props: {
              className: domClassMerge('whatsapp-nudge__icon', {
                'whatsapp-nudge__icon--disabled': whatsAppClicked,
              }),
            },
          }}
          className='whatsapp-nudge__button'
        >
          {i18nTranslate(whatsAppClicked ? 'PropertyCard_GalleryWhatsAppNudgeButtonDisabledLabel' : 'WhatsApp')}
        </Button>
      </div>
    );
  };

  return Component;
};
